import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';
import { useDealContext } from '../../utils/context/DealContext.tsx';

export function useOnBehalfOfAccountId(): string {
  const { session } = usePermissionContext();

  const { onBehalfOrganization } = useDealContext();

  const onBehalfOfAccountId = onBehalfOrganization
    ? onBehalfOrganization.exchange_account_network?.uid
    : session?.account.uid;

  return onBehalfOfAccountId as string;
}
